export function isServerResponseError(error) {
    if (isObject(error) && 'status' in error && 'data' in error)
        return true;
    return false;
}
function isObject(obj) {
    return typeof obj === 'object' && !Array.isArray(obj) && obj !== null;
}
